<template>
  <CModal :title="$t('repairOrderModal.title')" icon="link" @close="close">
    <template #body>
      <CCard v-if="hasRecentJobs" theme="info" class="u-mb-3">
        <CColor theme="info">
          <CItem icon="link" :body="$t('repairOrderModal.hasRecentJobs')" class="u-medium"/>
        </CColor>
      </CCard>

      <template v-if="context.items.length > 0">
        <CRepairOrderJob v-for="job in context.jobs" :job :context class="u-mb-3"/>

        <CSectionCard v-if="unassignedItems.length > 0" :title="$t('repairOrderModal.unassigned')" icon="link-broken" class="u-mb-3">
          <CRepairOrderItem v-for="item in unassignedItems" :item :context/>
        </CSectionCard>

        <CSectionCard v-if="deletedItems.length > 0" :title="$t('repairOrderModal.deleted')" icon="delete-trash">
          <CRepairOrderItem v-for="item in deletedItems" :item :context/>
        </CSectionCard>
      </template>

      <CRemark v-else>{{ $t('repairOrderModal.noInvoiceItems') }}</CRemark>
    </template>

    <template #footer>
      <CButton @click="close">{{ $t('general.close') }}</CButton>
    </template>
  </CModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CModal from '@/general/components/CModal.vue';
  import CCard from '@/shared/components/CCard.vue';
  import CColor from '@/shared/components/CColor.vue';
  import CItem from '@/shared/components/CItem.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import CRemark from '@/shared/components/form/CRemark.vue';
  import CSectionCard from '@/shared/components/section/CSectionCard.vue';
  import CRepairOrderItem from '../components/item/CRepairOrderItem.vue';
  import CRepairOrderJob from '../components/item/CRepairOrderJob.vue';
  import JobContext from '../models/JobContext';

  // TODO DONT DELETE THIS MODAL (not being used atm, but client wants to keep it to potentially use in the future)

  const emit = defineEmits<{ (e: 'close'): void }>();

  const props = defineProps<{
    context: JobContext;
  }>();

  const hasRecentJobs = computed(() => props.context.items.some(item => item.isRecent));

  const unassignedItems = computed(() => props.context.items.filter(i => i.jobId === null && !i.deletedOn));

  const deletedItems = computed(() => props.context.items.filter(i => i.deletedOn !== null));

  function close() {
    emit('close');
  }
</script>